var exports = {
  "Nr": "AccountSecurityCard.module__card___ZUhqNn",
  "nL": "AccountSecurityCard.module__headerless___ZUhqNn",
  "Ge": "AccountSecurityCard.module__rows___ZUhqNn",
  "wx": "AccountSecurityCard.module__header___ZUhqNn",
  "TK": "AccountSecurityCard.module__headerText___ZUhqNn",
  "$": "AccountSecurityCard.module__titleRow___ZUhqNn",
  "DD": "AccountSecurityCard.module__title___ZUhqNn",
  "h_": "AccountSecurityCard.module__description___ZUhqNn",
  "QE": "AccountSecurityCard.module__headerAction___ZUhqNn",
  "nM": "AccountSecurityCard.module__row___ZUhqNn",
  "qg": "AccountSecurityCard.module__rowText___ZUhqNn",
  "xZ": "AccountSecurityCard.module__rowLabel___ZUhqNn",
  "Z$": "AccountSecurityCard.module__rowDescription___ZUhqNn",
  "TF": "AccountSecurityCard.module__rowWarning___ZUhqNn",
  "cm": "AccountSecurityCard.module__rowActions___ZUhqNn",
  "OL": "AccountSecurityCard.module__emptyRow___ZUhqNn",
  "xH": "AccountSecurityCard.module__switchRow___ZUhqNn",
};

module.exports = exports;
